
import { CreateStatementOfAccountsReduxState, StatementOfAccountsReducerDispatch, StatementOfAccountsReduxTypes } from "./types"

const CREATE_STATEMENT_OF_ACCOUNTS_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateStatementOfAccountsReducer = (state: CreateStatementOfAccountsReduxState = CREATE_STATEMENT_OF_ACCOUNTS_INIT_STATE, action: StatementOfAccountsReducerDispatch) => {
    switch (action.type) {
        case StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT:
            return {
                ...state,
                loading: true
            }

        case StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }

        case StatementOfAccountsReduxTypes.STATEMENT_OF_ACCOUNTS_REPORT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        default:
            return { ...state }
    }
}

export { CreateStatementOfAccountsReducer }